interface BudgetData {
	allowance?: number;
	balance?: number;
	delegateName?: string;
	display: {
		singular: string;
		plural: string;
	};
	flashPointsBalance?: number;
	format: {
		singular: string;
		plural: string;
	};
}

export class Budget {
	constructor(public data: BudgetData) {}

	format(amount: number, lang = 'en') {
		const formattedNumber = new Intl.NumberFormat(lang).format(amount);

		const token = amount === 1 ? this.data.format.singular : this.data.format.plural;

		return token.replace('[X]', formattedNumber);
	}

	formattedBalance() {
		return this.format(Number(this.data.balance));
	}

	get monthlyAllowanceBalance() {
		return Math.max((this.data.balance ?? 0) - (this.data.flashPointsBalance ?? 0), 0);
	}

	get hasAllowance() {
		return typeof this.data.allowance === 'number';
	}
}
